import React from 'react';

import useDebugPanel from './useDebugPanel';
import Button from './Button';
import Panel from './Panel';

const DebugPanel = (props) => {
  const {
    view,
    onClickButton,
    onClosePanel,
  } = useDebugPanel();

  switch (view) {
    case 'panel': {
      return (
        <Panel
          onClose={onClosePanel}
          {...props}
        />
      );
    }
    case 'button': {
      return (
        <Button
          onClick={onClickButton}
        />
      );
    }
    default: {
      return null;
    }
  }
};

export default DebugPanel;
